/**
 * API клиент для работы с привязкой Telegram
 * Дата: 27.12.2025 - Создан для TODO-007 (отправка ссылки привязки Telegram)
 * Дата: 10.01.2026 - Добавлен requestContact для TODO-012b (Reverse Linking)
 * Связан с: internal/handler/linking.go, frontend/src/hooks/useLinking.ts
 */
import { apiClient } from './client';

export interface GenerateLinkRequest {
  phone: string;
  messenger?: 'telegram' | 'max';
}

export interface GenerateLinkResponse {
  token: string;
  deep_link: string;
  expires_at: string;
}

export interface SendLinkRequest {
  phone: string;
  channel: 'whatsapp' | 'sms';
  messenger?: 'telegram' | 'max';
}

export interface SendLinkResponse {
  success: boolean;
  sent: boolean;       // 12.02.2026 — true если SMS/WA реально отправлена
  send_error?: string; // 12.02.2026 — причина если sent=false
  deep_link: string;
  expires_at: string;
}

export interface RequestContactRequest {
  messenger_id: string;
  channel: 'telegram_bot' | 'telegram_client' | 'max';
  tenant_id?: string; // Дата: 15.01.2026 - для SuperAdmin
}

export interface RequestContactResponse {
  request_id: string;
  status: 'pending' | 'sent';
  sent_at: string;
}

export const linkingApi = {
  // Дата: 15.01.2026 - Добавлен tenantId для SuperAdmin
  generateLink: async (data: GenerateLinkRequest, tenantId?: string): Promise<GenerateLinkResponse> => {
    const params: Record<string, string> = {};
    if (tenantId) params.tenant_id = tenantId;
    const response = await apiClient.post('/linking/generate-link', data, { params });
    return response.data;
  },
  // Дата: 15.01.2026 - Добавлен tenantId для SuperAdmin
  sendLink: async (data: SendLinkRequest, tenantId?: string): Promise<SendLinkResponse> => {
    const params: Record<string, string> = {};
    if (tenantId) params.tenant_id = tenantId;
    const response = await apiClient.post('/linking/send-link', data, { params });
    return response.data;
  },
  
  // Дата: 10.01.2026 - Добавлено для TODO-012b (Reverse Linking)
  // Дата: 15.01.2026 - Добавлен tenantId для SuperAdmin
  requestContact: async (data: RequestContactRequest): Promise<RequestContactResponse> => {
    const params: Record<string, string> = {};
    if (data.tenant_id) params.tenant_id = data.tenant_id;
    const { tenant_id, ...body } = data; // Убираем tenant_id из body
    const response = await apiClient.post('/linking/request-contact', body, { params });
    return response.data;
  },
};

